/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../quiz-api";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateQuiz = /* GraphQL */ `subscription OnCreateQuiz(
  $ownerId: String
) {
  onCreateQuiz(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    creator
    name
    requiredPassPercentage
    version
    description
    createdAt
    latestEditor
    stats
    updatedAt
    publication_state
    relatedPages
    questionsCount
    questionsOrder
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateQuizSubscriptionVariables,
    APITypes.OnCreateQuizSubscription
>;
export const onUpdateQuiz = /* GraphQL */ `subscription OnUpdateQuiz(
  $ownerId: String
) {
  onUpdateQuiz(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    creator
    name
    requiredPassPercentage
    version
    description
    createdAt
    latestEditor
    updatedAt
    publication_state
    relatedPages
    stats
    questionsCount
    questionsOrder
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateQuizSubscriptionVariables,
    APITypes.OnUpdateQuizSubscription
>;
export const onDeleteQuiz = /* GraphQL */ `subscription OnDeleteQuiz(
  $ownerId: String
) {
  onDeleteQuiz(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    creator
    name
    requiredPassPercentage
    version
    description
    createdAt
    latestEditor
    stats
    updatedAt
    publication_state
    relatedPages
    questionsCount
    questionsOrder
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteQuizSubscriptionVariables,
    APITypes.OnDeleteQuizSubscription
>;
export const onCreateQuizQuestion = /* GraphQL */ `subscription OnCreateQuizQuestion(
  $ownerId: String
) {
  onCreateQuizQuestion(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizId
    text
    options
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateQuizQuestionSubscriptionVariables,
    APITypes.OnCreateQuizQuestionSubscription
>;
export const onUpdateQuizQuestion = /* GraphQL */ `subscription OnUpdateQuizQuestion(
  $ownerId: String
) {
  onUpdateQuizQuestion(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizId
    text
    options
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateQuizQuestionSubscriptionVariables,
    APITypes.OnUpdateQuizQuestionSubscription
>;
export const onDeleteQuizQuestion = /* GraphQL */ `subscription OnDeleteQuizQuestion(
  $ownerId: String
) {
  onDeleteQuizQuestion(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizId
    text
    options
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteQuizQuestionSubscriptionVariables,
    APITypes.OnDeleteQuizQuestionSubscription
>;
export const onCreateQuizAnswer = /* GraphQL */ `subscription OnCreateQuizAnswer(
  $ownerId: String
) {
  onCreateQuizAnswer(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    attempt
    completedAt
    duration
    answers
    score
    status
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateQuizAnswerSubscriptionVariables,
    APITypes.OnCreateQuizAnswerSubscription
>;
export const onUpdateQuizAnswer = /* GraphQL */ `subscription OnUpdateQuizAnswer(
  $ownerId: String
) {
  onUpdateQuizAnswer(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    attempt
    completedAt
    duration
    answers
    score
    status
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateQuizAnswerSubscriptionVariables,
    APITypes.OnUpdateQuizAnswerSubscription
>;
export const onDeleteQuizAnswer = /* GraphQL */ `subscription OnDeleteQuizAnswer(
  $ownerId: String
) {
  onDeleteQuizAnswer(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    attempt
    completedAt
    duration
    answers
    score
    status
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteQuizAnswerSubscriptionVariables,
    APITypes.OnDeleteQuizAnswerSubscription
>;
export const onCreateQuizStats = /* GraphQL */ `subscription OnCreateQuizStats(
  $ownerId: String
) {
  onCreateQuizStats(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    answerId
    completedAt
    attempt
    score
    status
    userIdAndStatus
    completePercentage
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateQuizStatsSubscriptionVariables,
    APITypes.OnCreateQuizStatsSubscription
>;
export const onUpdateQuizStats = /* GraphQL */ `subscription OnUpdateQuizStats(
  $ownerId: String
) {
  onUpdateQuizStats(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    answerId
    completedAt
    attempt
    score
    status
    userIdAndStatus
    completePercentage
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateQuizStatsSubscriptionVariables,
    APITypes.OnUpdateQuizStatsSubscription
>;
export const onDeleteQuizStats = /* GraphQL */ `subscription OnDeleteQuizStats(
  $ownerId: String
) {
  onDeleteQuizStats(ownerIdAndWsId: $ownerId) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    answerId
    completedAt
    attempt
    score
    status
    userIdAndStatus
    completePercentage
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteQuizStatsSubscriptionVariables,
    APITypes.OnDeleteQuizStatsSubscription
>;
